var Padding = /** @class */ (function () {
    function Padding(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'left,top,right,bottom,all,horizental,vertical';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Padding.prototype.toJSON = function () {
        return {
            "left": this.left,
            "top": this.top,
            "right": this.right,
            "bottom": this.bottom,
            "all": this.all,
            "horizental": this.horizental,
            "vertical": this.vertical
        };
    };
    Padding.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Padding;
}());
export { Padding };
//# sourceMappingURL=padding.js.map